<template>
  <el-dialog title="Account Edit" :width="dialogWidth" :visible="visible" :close-on-click-modal="false" @close="visible = false">
    <el-form ref="form" :model="ruleForm" :rules="rules" label-position="top" v-loading="form_loading" label-width="150px">
      <el-form-item label="Email">
        <el-input v-model="ruleForm.email" placeholder="Email" disabled></el-input>
      </el-form-item>
      <el-form-item label="Full Name" prop="fullName">
        <el-input v-model="ruleForm.fullName" placeholder="Full Name"></el-input>
      </el-form-item>
      <el-form-item label="Practice Name" prop="practiceName">
        <el-input v-model="ruleForm.practiceName" placeholder="Practice Name"></el-input>
      </el-form-item>
      <el-form-item label="Phone Number" prop="phoneNumber">
        <el-input v-model="ruleForm.phoneNumber" placeholder="Phone Number" @change="change_phone">
          <template slot="prepend">+1</template>
        </el-input>
      </el-form-item>


      <el-form-item label="country" prop="country">
        <el-select v-model="ruleForm.country" style="width: 100%;" placeholder="state">
          <el-option
            v-for="item,index in countryList"
            :key="index"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="state" prop="state">
        <el-select v-model="ruleForm.state" style="width: 100%;" placeholder="state">
          <el-option
            v-for="item,index in stateList"
            :key="index"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="city" prop="city">
        <el-input v-model="ruleForm.city" placeholder="city"></el-input>
      </el-form-item>
      <el-form-item label="zip Code" prop="zipCode">
        <el-input v-model="ruleForm.zipCode" placeholder="zip Code"></el-input>
      </el-form-item>
      <el-form-item label="address1" prop="address1">
        <el-input v-model="ruleForm.address1" placeholder="address1"></el-input>
      </el-form-item>
      <el-form-item label="address2" prop="address2">
        <el-input v-model="ruleForm.address2" placeholder="address2"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" style="background-color: #034844;border-color:#034844;" @click="submitForm">Save</el-button>
        <el-button @click="visible = false">Cancel</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import Vue from 'vue';
import moment from 'moment/moment';
import { postAction,getAction } from '@/network/manage';
export default {
  name: 'Edit',
  components: {},
  data() {
    return {
      dialogWidth:'600px',
      id: '',
      visible:false,
      ruleForm:{},
      countryList:['UNITED_STATES', 'CANADA', 'MEXICO', 'BRAZIL', 'ARGENTINA', 'UNITED_KINGDOM', 'FRANCE', 'GERMANY', 'ITALY', 'SPAIN', 'RUSSIA', 'CHINA', 'INDIA', 'JAPAN', 'AUSTRALIA', 'SOUTH_AFRICA', 'EGYPT', 'NIGERIA', 'SAUDI_ARABIA', 'TURKEY', 'SOUTH_KOREA', 'INDONESIA', 'PAKISTAN', 'BANGLADESH', 'VIETNAM', 'THAILAND', 'MALAYSIA', 'PHILIPPINES', 'SINGAPORE', 'NEW_ZEALAND', 'NORWAY', 'SWEDEN', 'DENMARK', 'FINLAND', 'POLAND', 'UKRAINE', 'NETHERLANDS', 'BELGIUM', 'SWITZERLAND', 'AUSTRIA', 'GREECE', 'PORTUGAL', 'CZECH_REPUBLIC', 'HUNGARY', 'ROMANIA', 'SLOVAKIA', 'BULGARIA', 'IRELAND', 'ICELAND', 'ISRAEL', 'IRAN', 'IRAQ', 'AFGHANISTAN', 'SYRIA', 'LEBANON', 'JORDAN', 'KUWAIT', 'QATAR', 'UNITED_ARAB_EMIRATES', 'OMAN', 'YEMEN', 'ETHIOPIA', 'KENYA', 'TANZANIA', 'UGANDA', 'ZIMBABWE', 'GHANA', 'ALGERIA', 'MOROCCO', 'TUNISIA', 'LIBYA', 'SUDAN', 'CHILE', 'PERU', 'COLOMBIA', 'VENEZUELA', 'ECUADOR', 'PARAGUAY', 'URUGUAY', 'BOLIVIA', 'PANAMA', 'COSTA_RICA', 'CUBA', 'HONDURAS', 'EL_SALVADOR', 'GUATEMALA', 'NICARAGUA', 'DOMINICAN_REPUBLIC', 'HAITI', 'JAMAICA', 'TRINIDAD_AND_TOBAGO'],
      stateList:['AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'],
      rules: {
      },
      form_loading: false,
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  computed: {

  },
  created() {
    this.setDialogWidth()
  },
  methods: {
    moment,
    change_phone() {
      if(!this.ruleForm.phoneNumber) {
        return;
      }
      let phone = this.ruleForm.phoneNumber.replaceAll("-", "").replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replace(/[^0-9]/g, '')
      if(phone.length != 10) {
        this.$message({
          message: 'Please enter the correct phone number.',
          type: 'warning'
        });
        this.ruleForm.phoneNumber = ""
        return;
      }
      phone = "+1" + phone
      this.ruleForm.phoneNumber = "(" + phone.substring(2,5) + ") " + phone.substring(5,8) + " - " + phone.substring(8);
    },
    init(id) {
      this.visible = true
      this.form_loading = true
      getAction('/admin/accountManagement/queryById?id='+id).then((res) => {
        if(res.success){
          this.ruleForm = res.result
          if(this.ruleForm.phoneNumber) {
            let phone = this.ruleForm.phoneNumber
            this.ruleForm.phoneNumber = "(" + phone.substring(2,5) + ") " + phone.substring(5,8) + " - " + phone.substring(8);
          }
          if(this.ruleForm.country == null)
            this.$set(this.ruleForm,'country','UNITED_STATES')
        }else{
          this.$message.error(res.message);
        }
      }).catch((err) => {
        this.$message.error(err.message);
      }).finally((res) => {
        this.form_loading = false
      });
    },
    submitForm() {
      const that = this
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.form_loading = true
          const params = {
            id:that.ruleForm.id,
            fullName:that.ruleForm.fullName,
            practiceName:that.ruleForm.practiceName,
            phoneNumber:that.ruleForm.phoneNumber,
            address1:that.ruleForm.address1,
            address2:that.ruleForm.address2,
            city:that.ruleForm.city,
            state:that.ruleForm.state,
            zipCode:that.ruleForm.zipCode,
            country:that.ruleForm.country
          }
          params.phoneNumber = "+1" + that.ruleForm.phoneNumber.replaceAll(" ", "").replaceAll("-", "").replaceAll("(", "").replaceAll(")", "")
          postAction('/admin/accountManagement/edit',params).then((res) => {
            if(res.success){
              that.$message({
                message: 'reset success!',
                type: 'success'
              });
              that.visible = false
              that.$emit('ok')
            }else{
              that.$message.error(res.message);
            }
          }).catch((err) => {
            that.$message.error(err.message);
          }).finally((res) => {
            that.form_loading = false
          });
        }
      });
    },
    setDialogWidth() {
      var val = document.body.clientWidth
      const def = 600 // default width
      if (val < def) {
        this.dialogWidth = '100%'
      } else {
        this.dialogWidth = def + 'px'
      }
    }
  }
}
</script>

<style scoped>
  .form{display: grid;grid-template-columns:1fr 1fr;}
  .form .flex{display: flex;justify-content: space-between;min-height:60px;align-items: center;font-size: 14px;}
  .border{border-bottom: 1px solid #EDF2F7;}
  .left{border-right: 1px solid #EDF2F7;padding-right:30px;margin-right: 30px;}
  .form a{font-size: 18px;font-weight: bold;color: #5856D6;width: 100%;text-align: center;}
  >>>.el-dialog__header{border-bottom:1px solid #dddddd;padding:15px 20px;}
  >>>.el-dialog__body{padding:20px;}
  >>>.el-form-item__label{line-height: 1;}
  h1{font-size: 18px;margin:20px 0;}
  b{font-size: 18px;}
  p{font-size: 14px;}
  .label{display:flex;}
  .label span{margin:0 10px 10px 0;}
  @media (max-width: 768px) {
     .form{display: grid;grid-template-columns:1fr;}
     .left{border-right: 0px solid #EDF2F7;padding-right:0;margin-right: 0;}
  }
</style>
